import { useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import s from './MoveFilesModal.scss'
import Select from 'react-select'

const MoveFilesModal = ({ showMoveFilesModal, toggleMoveFilesModal, folders, moveFiles }) => {
  const [selectedFolder, setSelectedFolder] = useState(null)
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showMoveFilesModal}
        toggle={toggleMoveFilesModal}
        size={'md'}
      >
        <ModalHeader toggle={toggleMoveFilesModal}>Move Files</ModalHeader>
        <ModalBody className={s.modalBody}>
          <p className={s.title}>Select the folder you want to move the files to</p>
          <Select
            className={s.select}
            onChange={setSelectedFolder}
            options={folders}
            value={selectedFolder}
          />
        </ModalBody>
        <ModalFooter>
          <Button className={s.saveBtn} disabled={false} onClick={() => moveFiles(selectedFolder)}>
            Confirm
          </Button>
          <Button color="secondary" onClick={toggleMoveFilesModal}>
            No
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default MoveFilesModal
